// extracted by mini-css-extract-plugin
export default {"iconBox":"tableColumns_iconBox__+ZbIk","popularBox":"tableColumns_popularBox__kzpRo","hideRow":"tableColumns_hideRow__62Y1Q"};